import React, 
{ 
    useEffect,
    useState 
} from 'react'

import toast from 'react-hot-toast';
import dayjs from 'dayjs';
import imageCompression from 'browser-image-compression';

import { 
    Delete,
    Edit,
} from '@mui/icons-material';

import ProfilePictureUpload from '../ProfilePictureUpload/ProfilePictureUpload'
import profileUrl from '../../Assets/user-profile-icon-free-vector.jpg'

import { 
    Form,
    Input,
    Col, 
    Row,
    Divider,
    Table,
    Space,
    Button,
    Avatar,
    Upload,
    DatePicker,
    message,
    Select,
    Modal,
} from 'antd';
import { UserOutlined } from '@ant-design/icons';

// import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
// import { formatDate } from '../../Utils/Common';
// import { formatDate } from '../../Utils/Common';

const { Item } = Form;
const { TextArea } = Input;
const { Option } = Select;


const Dependents = ({dependentsData, fetchMembersData, isLoading, id}) => {
    const [dependentsForm] = Form.useForm();
    const today = dayjs();
    const [spouseAttachment, setSpouseAttachment] = useState(false);
    const [dependentsInfoData, setDependentsInfoData] = useState([])
    const [isDisabled, setIsDisabled] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalImage, setModalImage] = useState(false);
    const acceptImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];
    const { callPost, loading} = usePostRequest(()=>{
        fetchMembersData();
    });

    const handleImageUpload = async (file) => {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 300,
          useWebWorker: true,
        };
        try {
          const compressedFile = await imageCompression(file, options);
          return compressedFile;
        } catch (error) {
          toast.error('Invalid File: ',error)
        }
    };

    const handleSaveImage = async (data) => {
        const compressedFile = await handleImageUpload(data.file);
        setSpouseAttachment(compressedFile)
    };

    const handleDelete = (key) => {
        const newData = [...dependentsInfoData];
        newData.splice(key, 1); 
        setDependentsInfoData(() => newData)
    };

    const addRow = () => {
        const newData = [...dependentsInfoData];
        newData.push({
            names: '',
            id_nos: '',
            account_nos: '',
            birthdates: '',
            ages: '',
            sexes: '',
            stats: '',
            dependent_expiry_dates: '',
            img: '',
            image_file: null,
            isWritable: true,
        });
        setDependentsInfoData(newData);
    };
    
    const handleTable = (e, index, name, isDate) => {
        if(isDate){
            setDependentsInfoData(prevState => {
                const newState = [...prevState];
                newState[index] = { 
                    ...newState[index],
                    [name]: e
                };
                return newState;
            });
        } else if(name === "birthdates"){
            if (e) {
                const today = dayjs();
                const birthdate = dayjs(e);
                const calculatedAge = today.diff(birthdate, 'years');
                setDependentsInfoData(prevState => {
                    const newState = [...prevState];
                    newState[index] = { 
                        ...newState[index],
                        [name]: e,
                        ages: calculatedAge
                    };
                    return newState;
                });
            }
        } else {
            const { value } = e.target

            setDependentsInfoData(prevState => {
            const newState = [...prevState];
            newState[index] = { 
                ...newState[index],
                [name]: value
            };
                return newState;
            });
        }
    }

    const handleRowClick = (row_id) => {
        const newData = dependentsInfoData?.map((item, index) => ({
          ...item,
          isWritable: row_id === index ? !item.isWritable : item.isWritable,
        }));
        setDependentsInfoData(newData);
    };

    const defaultColumns = [
        {
            title: (
                <span>
                  Name <span style={{ color: 'red' }}>*</span>
                </span>
            ),
            dataIndex: 'names',
            align: 'center',
            key: 'names',
            render: (_, record, index) => (
            record.isWritable ? (
                <Row>
                    <Col span={8} align='center'>
                        <Upload
                            name="avatar"
                            listType="picture"
                            className="avatar-uploader"
                            showUploadList={false}
                            // action="/upload.do"
                            accept={acceptImageTypes.join(',')}
                            beforeUpload={() => false} // To prevent immediate upload
                            onChange={(info) => handleChange(info,index)}
                        >   
                            {record?.img ? (
                                <Avatar
                                    size={40}
                                    icon={record.img}
                                    src={record.img}
                                />
                            ) : (
                                <Avatar
                                    size={40}
                                    icon={<UserOutlined/>}
                                    // src={profileUrl}
                                />
                            )}
                        </Upload>
                    </Col>
                    <Col span={16} align='center'>
                        <Input
                            value={record.names}
                            onChange={(e) => handleTable(e, index, "names")}
                        />
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col span={8} align='center'>
                        <Avatar 
                            src={record.img || profileUrl} 
                            style={{ marginRight: 8,  cursor: 'pointer'  }} 
                            onClick={() => showModal(record.img)}
                        />
                    </Col>
                    <Col span={16} align='center'>
                        {record.names}
                    </Col>
                </Row>
            )
          ),
        },
        {
            title: 'ID',
            dataIndex: 'id_nos',
            align: 'center',
            key: 'id_nos',
            render: (_, record, index) => (
            record.isWritable ? (
               
                <Input
                    value={record.id_nos}
                    onChange={(e) => handleTable(e, index, "id_nos")}
                />
            ) : record.id_nos
          ),
        },
        {
            title: 'Account No',
            dataIndex: 'account_nos',
            align: 'center',
            key: 'account_nos',
            render: (_, record, index) => (
            record.isWritable ? (
                
                <Input
                    value={record.account_nos}
                    onChange={(e) => handleTable(e, index, "account_nos")}
                />
            ) : record.account_nos
          ),
        },
        {
            title: (
                <span>
                  Birthdate <span style={{ color: 'red' }}>*</span>
                </span>
            ),
            dataIndex: 'birthdates',
            align: 'center',
            key: 'birthdates',
            render: (_, record, index) => (
            record.isWritable ? (
                <DatePicker        
                    style={{width:'100%'}}
                    value={record.birthdates}
                    onChange={(e) => handleTable(e, index, "birthdates")}
                />
            ) : record.birthdates?.format('MMMM D, YYYY')
          ),
        },
        {
            title: 'Age',
            dataIndex: 'ages',
            align: 'center',
            key: 'ages', 
        },
        {
            title: 'Sex',
            dataIndex: 'sexes',
            align: 'center',
            key: 'sexes',
            render: (_, record, index) => (
            record.isWritable ? (
                <Select 
                    style={{width:'100%'}}
                    value={record.sexes}
                    placeholder="Select a Sex"  
                    onChange={(e) => handleTable(e, index, "sexes", true)}
                >
                    <Option value="Male">Male</Option>
                    <Option value="Female">Female</Option>
                </Select>
            ) : record.sexes    
          ),
        },
        {
            title: 'Stat',
            dataIndex: 'stats',
            align: 'center',
            key: 'stats',
            render: (_, record, index) => (
            record.isWritable ? (  
                <Select 
                    style={{width:'100%'}}
                    value={record.stats}
                    placeholder="Select a Stats" 
                    onChange={(e) => handleTable(e, index, "stats", true)}
                >
                    <Option value="Active">Active</Option>
                    <Option value="Expired">Expired</Option>
                </Select>
            ) : record.stats    
          ),
        },
        {
            title: 'Expiry Date',
            dataIndex: 'dependent_expiry_dates',
            align: 'center',
            key: 'dependent_expiry_dates',
            render: (_, record, index) => (
            record.isWritable ? ( 
                <DatePicker        
                    style={{width:'100%'}}
                    value={record.dependent_expiry_dates}
                    onChange={(e) => handleTable(e, index, "dependent_expiry_dates", true)}
                />
            ) :  record.dependent_expiry_dates ? record.dependent_expiry_dates?.format('MMMM D, YYYY') : ''
          ),
        },
        {
            title: '',
            dataIndex: '',
            align: 'center',
            render: (_, record, index) => (
                <Space>
                    {
                        (record.id) && (
                            <div 
                                onClick={() => handleRowClick(index)}
                                className='cursor'
                            >
                                <Edit/>
                            </div>
                        )
                    }
                    <div 
                        onClick={() => handleDelete(index)}
                        className='cursor'
                    >
                        <Delete  
                            style={{
                                color: 'red',
                            }}
                        />
                    </div>
                </Space>
            ),
            onCell: () => ({
                onClick: (e) => {
                    e.stopPropagation();
                },
            }),
        },
    ];

    const handleImageFileRead = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
    };
      
    const updateDependentInfo = (index, result, file) => {
        setDependentsInfoData(prevState => {
          const newState = [...prevState];
          newState[index] = {
            ...newState[index],
            img: result,
            image_file: file,
          };
          return newState;
        });
    };
      
    const handleChange = async (info, index) => {
        const isImage = info.file.type.startsWith('image/');
      
        if (isImage) {
          setTimeout(async () => {
            try {
              const result = await handleImageFileRead(info.file);
              const file = await handleImageUpload(info.file);
              updateDependentInfo(index, result, file);
            } catch (error) {
              message.error('Error reading the image file.');
            }
          }, 500);
        } else {
          message.error('Please upload a valid image file (JPEG, PNG, GIF, BMP).');
        }
    };
      
      

    async function urlToFile(url) {
        // Fetch the URL and get the response as a Blob
        const response = await fetch(url);
        const blob = await response.blob();
    
        // Create a File from the Blob
        const formImage = new File([blob], 'image.jpeg', {
            type: blob.type,
        });
    
        return formImage;
    }

    const handleCreateAddress = async () => {
        try {
            // Wait for form validation
            const values = await dependentsForm.validateFields();
            
            // Prepare new values
            const newValues = {
                member_id: id,
                spouse_name: values?.spouse_name || " ",
                telephone: values?.telephone || " ",
                insurance: values?.insurance || " ",
                information: values?.information || " ",
                spouse_pic: spouseAttachment || " ",
                expiry_date: values?.expiry_date ? values.expiry_date.format("YYYY-MM-DD") : " " ,
            };
    
            // Map other values
            newValues.id = dependentsInfoData?.map((item) => item.id || " ");
            newValues.names = dependentsInfoData?.map((item) => item.names || " ");
            newValues.id_nos = dependentsInfoData?.map((item) => item.id_nos || " ");
            newValues.account_nos = dependentsInfoData?.map((item) => item.account_nos || " ");
            newValues.ages = dependentsInfoData?.map((item) => item.ages || " ");
            newValues.sexes = dependentsInfoData?.map((item) => item.sexes || " ");
            newValues.its = dependentsInfoData?.map((item) => item.its || " ");
            newValues.stats = dependentsInfoData?.map((item) => item.stats || " ");
            newValues.birthdates = dependentsInfoData?.map((item) => item.birthdates ? item.birthdates.format("YYYY-MM-DD") : "");
            newValues.dependent_expiry_dates = dependentsInfoData?.map((item) => item.dependent_expiry_dates ? item.dependent_expiry_dates.format("YYYY-MM-DD") : "");
    
            const dependentPics = await Promise.all(dependentsInfoData?.map(async (item) => {
                if (typeof item?.image_file === "string") {
                    const file = await urlToFile(item?.image_file); // Assuming item.image_file contains the URL
                    return file;
                } else if(item?.image_file === null){
                    const file = await urlToFile(profileUrl); // Assuming item.image_file contains the URL
                    return file;
                } else {
                    return item?.image_file;
                }
            }));
            
            newValues.dependent_pics = dependentPics;
    
            // Prepare final values
            const finalValues = Object.entries(newValues)?.map(([key, value]) => ({
                key,
                value,
            }));
    
            // Call API
            await callPost("/members/update_dependent", finalValues, true);
    
        } catch (errorInfo) {
            toast.error('Validation Failed', errorInfo);
        }
    };

    const showModal = (img) => {
      setIsModalVisible(true);
      setModalImage(img)
    };
  
    const handleCancel = () => {
      setIsModalVisible(false);
      setModalImage('')
    };

    useEffect(() => {
        const allFieldsFilled = dependentsInfoData.every(dependent => {
          return dependent.name !== '' && dependent.birthdates !== '';
        });
        setIsDisabled(!(allFieldsFilled));
    }, [dependentsInfoData]);
    
    useEffect(() => {
        if(dependentsData){
            dependentsForm.setFieldsValue({
                spouse_name: dependentsData[0]?.spouse_name,
                telephone: dependentsData[0]?.telephone,
                insurance: dependentsData[0]?.insurance,
                expiry_date: dependentsData[0]?.expiry_date ? dayjs(dependentsData[0]?.expiry_date) : undefined,
                information: dependentsData[0]?.information,
            });

            setSpouseAttachment(dependentsData[0]?.spouse_pic_url)

            const dependents_data = dependentsData[0]?.dependent_items?.map((data) => ({
                id: data.id,
                member_dependent_id: data.member_dependent_id,
                names: data.name,
                id_nos: data.id_no,
                account_nos: data.account_no,
                birthdates: data.birthdate ? dayjs(data.birthdate) : undefined,
                ages: data.age,
                sexes: data.sex,
                its: data.it,
                stats: (data?.dependent_expiry_date !== "" && today.isAfter(dayjs(data?.dependent_expiry_date))) ? 'Expired' : 'Active',
                dependent_expiry_dates: data.dependent_expiry_date ? dayjs(data.dependent_expiry_date) : undefined,
                dependent_pic: data.dependent_pic,
                uploaded_by: data.uploaded_by,
                img: data.dependent_pic_url,
                image_file: data.dependent_pic_url,
                added_by: data.added_by,
                added_on: data.added_on,
                updated_by: data.updated_by,
                updated_on: data.updated_on,
                is_deleted: data.is_deleted,
            }))

            setDependentsInfoData(dependents_data || [])
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dependentsData, dependentsForm])

    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                    form={dependentsForm}
                >
                    <Divider className='divider-text'>SPOUSE</Divider>
                    <Row className='responsive-inline responsive-width mb-4'>
                        <Col 
                            xs={24} sm={24} md={24} lg={5} xl={5}
                            className='p-2'
                        >
                            <ProfilePictureUpload
                                imageUrl={spouseAttachment}
                                imageFile={handleSaveImage}
                            />
                        </Col>
                        <Col 
                            xs={19} sm={19} md={19} lg={19} xl={19}
                            className='p-2'
                        >
                            <Row className='responsive-inline responsive-width'>
                                <Col 
                                     xs={24} sm={24} md={24} lg={24} xl={24}
                                    className='p-2'
                                >
                                    <Item
                                        label="Spouse Name"
                                        name="spouse_name"
                                        className='p-0 m-0'
                                        // rules={[{ required: true, message: 'Please enter your Spouse Name!' }]}
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row className='responsive-inline responsive-width'>
                                <Col 
                                     xs={24} sm={24} md={24} lg={24} xl={24}
                                    className='p-2'
                                >
                                    <Item
                                        label="Telephone"
                                        name="telephone"
                                        className='p-0 m-0'
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row className='responsive-inline responsive-width'>
                                <Col 
                                     xs={24} sm={24} md={24} lg={12} xl={12}
                                    className='p-2'
                                >
                                    <Item
                                        label="Insurance"
                                        name="insurance"
                                        className='p-0 m-0'
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col 
                                     xs={24} sm={24} md={24} lg={12} xl={12}
                                    className='p-2'
                                >
                                    <Item
                                        label="Expiry Date"
                                        name="expiry_date"
                                        className='p-0 m-0'
                                    >
                                        <DatePicker        
                                            style={{width:'100%'}}
                                        />
                                    </Item>
                                </Col>
                            </Row>
                            <Row className='responsive-inline responsive-width mb-4'>
                                <Col 
                                    xs={24} sm={24} md={24} lg={24} xl={24}
                                    className='p-2'
                                >
                                    <Item
                                        label="Spouse Information"
                                        name="information"
                                        className='p-0 m-0'
                                    >
                                        <TextArea rows={4}/>
                                    </Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Divider className='divider-text'>DEPENDENTS</Divider>
                    <Row>
                        <Col span={24} className='responsive-overflow-y'>
                            <Table
                                bordered
                                dataSource={dependentsInfoData}
                                columns={defaultColumns}
                                pagination={false}
                                loading={isLoading}
                                scroll={{ x: 2000 }} 
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                        <Col span={24}>
                            <Button 
                                type="primary" 
                                onClick={addRow}
                            >
                                Add Row
                            </Button>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateAddress}
                                loading={loading}
                                type='primary'
                                disabled={isDisabled}
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
                <Modal
                    show={isModalVisible}
                    footer={null}
                    onCancel={handleCancel}
                >
                    <img
                    alt="modalImage"
                    style={{ width: '100%' }}
                    src={modalImage}
                    />
                </Modal>
            </Col>
        </Row>
    )
}
export default Dependents
